var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "plus-1",
    points: "943.34 177 943.34 189.35 954.962 189.35 954.962 197.34 943.34 197.34 943.34 208.963 935.349 208.963 935.349 197.34 923 197.34 923 189.35 935.349 189.35 935.349 177"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "plus-2",
    className: "fill-selector",
    fill: "#151515",
    fillRule: "evenodd",
    transform: "translate(-923 -177)",
    xlinkHref: "#plus-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.7989248a37b6502134c9851f2c1984ab.svg";
export { ForwardRef as ReactComponent };